import React, { useState } from 'react';
import { Box, Input, Radio, RadioGroup, Stack, Typography } from '@mui/joy';
import { DomainManager } from '../domains';

interface DomainStepProps {
  value: string;
  onChange: (domain: string) => void;
}

export const DomainStep: React.FC<DomainStepProps> = ({ value, onChange }) => {
  const [mode, setMode] = useState<'subdomain' | 'custom'>('subdomain');
  const [subdomain, setSubdomain] = useState('');

  const handleSubdomain = (val: string) => {
    const clean = val.toLowerCase().replace(/[^a-z0-9-]/g, '');
    setSubdomain(clean);
    onChange(clean ? `${clean}.example.com` : '');
  };

  return (
    <Box>
      <Typography level="h4" mb={2}>
        Choose Your Domain
      </Typography>
      <RadioGroup
        value={mode}
        onChange={(event) => {
          const val = event.target.value;
          setMode(val as 'subdomain' | 'custom');
          onChange('');
        }}
      >
        <Radio value="subdomain" label="Use a free subdomain" />
        <Radio value="custom" label="Use my own domain" />
      </RadioGroup>
      {mode === 'subdomain' ? (
        <Stack direction="row" spacing={1} mt={2}>
          <Input
            placeholder="myroofing"
            value={subdomain}
            onChange={(e) => handleSubdomain(e.target.value)}
            endDecorator=".example.com"
          />
        </Stack>
      ) : (
        <Box mt={2}>
          <DomainManager value={value} onChange={onChange} />
        </Box>
      )}
    </Box>
  );
};

export default DomainStep;
